import { snackbar } from "@/core/controller/snackbar_controller";
import { headers } from "../const/headers";
import { modelDefault } from "../domain/model/model";
import * as XLSX from "xlsx";

class ModelController {
  context = null;
  headers = headers
  loading = false
  loadingBtnExcel = false
  search = ""
  dialog = false
  form = modelDefault()
  statusSelected = 1
  statusList = [
    { text: "Todos", value: 0 },
    { text: "Ativo", value: 1 },
    { text: "Inativo", value: 2 },
  ]

  modelPagination = {
    total: 0,
    items: []
  }

  options = {
    page: 1,
    itemsPerPage: 40,
    groupBy: [],
    sortBy: ["name"],
    groupDesc: [],
    multiSort: false,
    mustSort: false,
    sortDesc: []
  }

  constructor(
    context,
    fetchModelUseCaseImpl,
    createModelUseCaseImpl,
    changeModelUseCaseImpl,
    deleteModelUseCaseImpl
  ) {
    this.context = context;
    this.fetchModelUseCaseImpl = fetchModelUseCaseImpl
    this.createModelUseCaseImpl = createModelUseCaseImpl
    this.changeModelUseCaseImpl = changeModelUseCaseImpl
    this.deleteModelUseCaseImpl = deleteModelUseCaseImpl
  }

  async paginate() {
    this.loading = true
    try {
      this.modelPagination = await this.fetchModelUseCaseImpl(this.options, this.search, this.statusSelected)
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false
    }
  }

  open() {
    this.form = modelDefault()
  }

  close() {
    this.context.$refs.crud.resetValidation()
    this.dialog = false
  }

  async create() {
    if (this.context.$refs.crud.validate()) {
      try {
        this.loading = true
        if (this.form.id != 0) {
          await this.changeModelUseCaseImpl(this.form.id, this.form)
          snackbar.show({ message: "Alterado com sucesso!!!", color: "#008000", timeout: 3000 })
        } else {
          await this.createModelUseCaseImpl(this.form)
          snackbar.show({ message: "Adicionado com sucesso!!!", color: "#008000", timeout: 3000 })
        }
      } catch (error) {
        snackbar.show({ message: error.toString(), color: "#ff0000", timeout: 3000 })
      } finally {
        this.paginate()
        this.loading = false
        this.dialog = false
      }
    }
  }

  change(item) {
    this.dialog = true
    this.form = { ...item }
  }

  async delete(item) {
    try {
      const confirm = await snackbar.confirm({ message: "Deseja realmente excluir o registro?", color: "primary", timeout: 5000 })
      if (confirm) {
        await this.deleteModelUseCaseImpl(item.id)
        this.paginate()
        snackbar.show({ message: "Resgistro excluído com sucesso!", color: "#008000", timeout: 1000 })
      }
    } catch (error) {
      snackbar.show({ message: error.toString() })
    }
  }


  watchOptions() {
    this.paginate()
  }

  watchSearch() {
    this.paginate()
  }

  changeStatus() {
    this.paginate()
  }

  async exportExcel() {
    try {
      const header = [['ID','NOME', 'DESCRICAO', 'VERSAO FIRMWARE']];
      this.loadingBtnExcel = true;
      const paginate = { ...this.options };
      paginate.itemsPerPage = 30000;
      const data = await this.fetchModelUseCaseImpl(paginate, "");
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet([]);
      XLSX.utils.sheet_add_aoa(ws, header);
      XLSX.utils.sheet_add_json(ws, data.items.map((item) => {
        return {
          id: item.id,
          name: item.name,
          description: item.description,
          firmwareVersion: item.firmwareVersion
        }
      }), { origin: 'A2', skipHeader: true });
      XLSX.utils.book_append_sheet(wb, ws, 'model');
      
      XLSX.writeFile(wb, `modelos.xlsx`);
    } catch (error) {
      snackbar.show({ message: error.toString() });
    } finally {
      this.loadingBtnExcel = false;
    }
  }

}

export default ModelController